import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

const PriceListProductAssignmentPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SectionWrapper>
        <div className="p-6">
          <h2 className="text-xl font-semibold text-black dark:text-white mb-4">
            Asignación de Productos
          </h2>
          <p className="text-gray-600 dark:text-gray-300">
            Asigna productos a listas de precios para personalizar tarifas.
          </p>
        </div>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default PriceListProductAssignmentPage;
